module.exports = __webpack_public_path__ + "img/ey-logo.4ad6194a.png";